import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { palletsTypes } from 'utils/pallets';

import { goToShipper, goToUser } from 'redux/modules/navigation/effects';

import DetailTitle from 'modules/Common/DetailTitle';
import ExtrasSummary from 'modules/Common/Details/ExtrasSummary';

import { ShipperName, TagsGroup } from 'modules/shipper-order/Card/components';
import UserInfo from 'modules/shipper-order/Card/sections/UserInfo';

import StopInfo from './StopInfo';

import { CargoItem } from './styled';

import { Flexer, Spacer } from '@ontruck/orc';

const t = {
  cargo_title: 'Cargo',
  stops_title: 'Stops',
};

class ROInfo extends PureComponent {
  constructor(props) {
    super(props);

    this.handleShipperClick = this.handleShipperClick.bind(this);
    this.handleUserClick = this.handleUserClick.bind(this);
  }

  handleShipperClick() {
    const { goToShipper, shipper } = this.props;
    goToShipper({ shipperId: shipper.id });
  }

  handleUserClick() {
    const { goToUser, user, shipper } = this.props;
    goToUser({ userId: user.id, shipperId: shipper.id });
  }

  render() {
    const { intl, shipper, user, order } = this.props;
    const { isPriority, isRecovering, isNew } = shipper;

    const messages = intl.messages;
    const units = messages.units;

    const stop = order.shipments[0];

    return (
      <Fragment>
        <Flexer.Child flexBasis="0" pLeft="M" flexGrow="1">
          <Flexer.Parent mBottom="L" flexDirection="column">
            <Spacer mBottom="XXS">
              <ShipperName name={shipper?.name} shipperId={shipper?.id} />
            </Spacer>
            <Spacer mBottom="XS">
              <TagsGroup isPriority={isPriority} isRecovering={isRecovering} isNew={isNew} />
            </Spacer>
          </Flexer.Parent>
          <Flexer.Parent flexDirection="column">
            <DetailTitle>{t.cargo_title}</DetailTitle>
            <Flexer.Parent>
              <CargoItem>
                {order.number_of_items} {palletsTypes.abbr[order.pallet_type]}
              </CargoItem>
              <CargoItem>
                {order.total_weight} {units.kg}
              </CargoItem>
              <CargoItem>
                {order.item_height / 100} {units.m}
              </CargoItem>
              <ExtrasSummary
                {...order}
                config={{
                  additionalDocuments: {
                    show: false,
                  },
                }}
                small
              />
            </Flexer.Parent>
          </Flexer.Parent>
        </Flexer.Child>
        <Flexer.Child flexBasis="0" pLeft="M" flexGrow="1">
          <Flexer.Parent mBottom="L" flexDirection="column">
            <UserInfo shipper={shipper} user={user} onUserClick={this.handleUserClick} />
          </Flexer.Parent>
          <Flexer.Parent flexDirection="column">
            <DetailTitle>{t.stops_title}</DetailTitle>
            <StopInfo
              firstStopTimeFrom={order.start_time_from}
              stop={{
                stop_type: 'PICKUP',
                address: `${stop.address_from.company_name} ${stop.address_from.label}`,
                time_from: order.start_time_from,
                time_to: order.start_time_to,
                extras: stop.extras,
              }}
            />
            <Spacer mBottom="XS" />
            <StopInfo
              firstStopTimeFrom={order.start_time_from}
              stop={{
                stop_type: 'DROPOFF',
                address: `${stop.address_to.company_name} ${stop.address_to.label}`,
                time_from: order.end_time_from,
                time_to: order.end_time_to,
                extras: stop.extras,
              }}
            />
          </Flexer.Parent>
        </Flexer.Child>
      </Fragment>
    );
  }
}

ROInfo.propTypes = {
  intl: PropTypes.any.isRequired,
  order: PropTypes.shape({}).isRequired,
  shipper: PropTypes.shape({}),
  user: PropTypes.shape({}),
  goToShipper: PropTypes.func.isRequired,
  goToUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = {
  goToShipper,
  goToUser,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ROInfo));
